import React from "react";
import UserLoginsModule from "./UserLoginsModule";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";

const UserLogins = (props) => {
  return (
    <Provider store={createReduxStore("userLoginsReducer")}>
      <ErrorBoundary moduleName="userLogins" {...props.notifications}>
        <UserLoginsModule
          orgId={props.organization_id}
          sourceType={props.sourceType}
          orgName={props.organization_name}
        />
      </ErrorBoundary>
    </Provider>
  );
};

export default UserLogins;
